export const ITEM_OBJ = {
	customer: {
		id: null,
		name: '---',
		created_date: null,
		location_id: null,
		phone: '---',
		email: '---',
	},
	consultation: {
		id: null,
		status: '---',
		status_system_name: '---',
		name: '---',
		code: '---',
		using_accessory_only: false,
		client_state: '---',
		current_client_state: '---',
		assigned_user_id: null,
		assigned_user_name: '---',
		created_date: null,
		presented_date: null,
		accepted_date: null,
		lost_date: null,
		expiration_date: null,
		accepted_proposal_id: null,
	},
};
export const NEW_CONSULTATION_SS = {
	consultation_name: null,
	consultation_id: null,
	consultation_client_state: 'proposal.customerCreate',
	status: 'draft',
};
export const ICON_CLASS = {
	down: 'chevron-down',
	up: 'chevron-up',
	refresh: 'info-circle',
};
//
export class NavigatorHelper {
	/** @ngInject */
	constructor($q, $log, ConsultationService, ServiceProviderUserService, EventLogService) {
		this.$q = $q;
		this.$log = $log;
		this.ConsultationSvc = ConsultationService;
		this.ServiceProviderUserSvc = ServiceProviderUserService;
		this.EventLogSvc = EventLogService;
	}

	/**
	 * Retrieves all consultation statuses for a service provider
	 * @param {Object} params - Parameters for the request
	 * @param {number} params.serviceProviderId - The service provider ID
	 * @param {number} params.userId - The user ID
	 * @returns {Promise<Array>} Promise that resolves to an array of consultation status objects
	 */
	getConsultationStatuses(params) {
		const errMsg = {display: 'Error getting consultation statuses'};
		const dfr = this.$q.defer();
		this.ConsultationSvc.getAllConsultationStatuses(params)
			.then(resObj => {
				const {data} = resObj;
				if (data?.success) dfr.resolve(Object.assign(data.payLoad));
				if (data?.error) dfr.reject(Object.assign(data.error, errMsg));
			})
			.catch(err => dfr.reject(Object.assign(err, errMsg)));
		return dfr.promise;
	}

	/**
	 * Retrieves detailed information for a specific consultation
	 * @param {Object} params - Parameters for the request
	 * @param {number} params.serviceProviderId - The service provider ID
	 * @param {number} params.userId - The user ID
	 * @param {number} params.consultationId - The consultation ID to get details for
	 * @returns {Promise<Object>} Promise that resolves to consultation details including customer, consultation, and proposals data
	 */
	getConsultationDetails(params) {
		const errMsg = {display: 'Error getting consultation details'};
		const dfr = this.$q.defer();
		this.ConsultationSvc.getDetails(params)
			.then(resObj => {
				const {data} = resObj;
				if (data?.success) dfr.resolve(Object.assign(data.payLoad));
				if (data?.error) dfr.reject(Object.assign(data.error, errMsg));
			})
			.catch(err => dfr.reject(Object.assign(err, errMsg)));
		return dfr.promise;
	}

	/**
	 * Retrieves all users associated with a service provider
	 * @param {Object} params - Parameters for the request
	 * @param {number} params.serviceProviderId - The service provider ID
	 * @param {number} params.userId - The user ID
	 * @returns {Promise<Array>} Promise that resolves to an array of user objects with id and name properties
	 */
	getAllUsersByProvider(params) {
		const errMsg = {display: 'Error getting all users by provider.'};
		const dfr = this.$q.defer();
		this.ServiceProviderUserSvc.getAllUsersByProvider(params)
			.then(resObj => {
				const {data} = resObj;
				if (data?.success) dfr.resolve(data.payLoad);
				if (data?.error) dfr.reject(Object.assign(data.error, errMsg));
			})
			.catch(err => dfr.reject(Object.assign(err, errMsg)));
		return dfr.promise;
	}

	/**
	 * Retrieves available date filter options for viewing consultations
	 * @param {Object} params - Parameters for the request
	 * @param {number} params.serviceProviderId - The service provider ID
	 * @param {number} params.userId - The user ID
	 * @param {string} params.statusJson - JSON string of selected status filters
	 * @returns {Promise<Array>} Promise that resolves to an array of date filter options with name and label properties
	 */
	getViewByDateFilterOptions(params) {
		const errMsg = {display: 'Error getting view by date options.'};
		const dfr = this.$q.defer();
		this.ConsultationSvc.getAllViewByDateOptions(params)
			.then(resObj => {
				const {data} = resObj;
				if (data?.success) dfr.resolve(data.payLoad);
				if (data?.error) dfr.reject(Object.assign(data.error, errMsg));
			})
			.catch(err => dfr.reject(Object.assign(err, errMsg)));
		return dfr.promise;
	}

	/**
	 * Retrieves event logs for a specific consultation
	 * @param {Object} params - Parameters for the request
	 * @param {number} params.serviceProviderId - The service provider ID
	 * @param {number} params.userId - The user ID
	 * @param {number} params.consultationId - The consultation ID to get logs for
	 * @returns {Promise<Object>} Promise that resolves to an object containing event_logs array, number_of_records, and proposals array
	 */
	getConsultationLogs(params) {
		const errMsg = {display: 'Error getting event logs'};
		const dfr = this.$q.defer();
		this.ConsultationSvc.getEventLogsByConsultationId(params)
			.then(resObj => {
				const {data} = resObj;
				if (data?.success) dfr.resolve(data.payLoad);
				if (data?.error) dfr.reject(Object.assign(data.error, errMsg));
			})
			.catch(err => dfr.reject(Object.assign(err.data.error, errMsg)));
		return dfr.promise;
	}

	/**
	 * Retrieves the lost note for a specific event log entry
	 * @param {Object} params - Parameters for the request
	 * @param {number} params.serviceProviderId - The service provider ID
	 * @param {number} params.userId - The user ID
	 * @param {number} params.eventLogId - The event log ID to get the lost note for
	 * @returns {Promise<Object>} Promise that resolves to an object containing lost_note text and id
	 */
	getEventLostNote(params) {
		const errMsg = {display: 'Error getting Lost Note'};
		const dfr = this.$q.defer();
		this.EventLogSvc.getLostNoteByEventLogId(params, true)
			.then(resObj => {
				const data = resObj.data;
				if (data?.success) dfr.resolve({lost_note: data.payLoad.body, id: params.eventLogId});
				if (data?.error) dfr.reject(Object.assign(errMsg, data.error));
			})
			.catch(err => dfr.reject(Object.assign(err.data.error, errMsg)));
		return dfr.promise;
	}

	/**
	 * Marks a consultation as lost with a reason and optional notes
	 * @param {Object} params - Parameters for the request
	 * @param {number} params.serviceProviderId - The service provider ID
	 * @param {number} params.userId - The user ID
	 * @param {number} params.consultationId - The consultation ID to mark as lost
	 * @param {number} params.reasonId - The ID of the lost reason
	 * @param {string} params.notes - Optional notes explaining why the consultation was lost
	 * @returns {Promise<Object>} Promise that resolves to the updated consultation data
	 */
	markConsultationLost(params) {
		const errMsg = {display: 'Error marking consultation lost'};
		const dfr = this.$q.defer();
		this.ConsultationSvc.postMarkAsLost(params)
			.then(resObj => {
				const {data} = resObj;
				if (data?.success) dfr.resolve(data.payLoad);
				if (data?.error) dfr.reject(Object.assign({}, errMsg, data.error));
			})
			.catch(err => dfr.reject(Object.assign(err.data.error, errMsg)));
		return dfr.promise;
	}

	/**
	 * Reverts a consultation's lost status back to its previous state
	 * @param {Object} params - Parameters for the request
	 * @param {number} params.serviceProviderId - The service provider ID
	 * @param {number} params.userId - The user ID
	 * @param {number} params.consultationId - The consultation ID to revert lost status for
	 * @returns {Promise<Object>} Promise that resolves to the updated consultation data
	 */
	revertLostStatus(params) {
		const errMsg = {display: 'Error reverting lost consultation'};
		const dfr = this.$q.defer();
		this.ConsultationSvc.postRevertLostStatus(params)
			.then(resObj => {
				const {data} = resObj;
				if (data?.success) dfr.resolve(data.payLoad);
				if (data?.error) dfr.reject(Object.assign({}, errMsg, data.error));
			})
			.catch(err => dfr.reject(Object.assign(err.data.error, errMsg)));
		return dfr.promise;
	}

	/**
	 * Loads customers and their associated consultations with filtering and pagination
	 * @param {Object} params - Parameters for the request
	 * @param {number} params.serviceProviderId - The service provider ID
	 * @param {number} params.userId - The user ID
	 * @param {string} [params.search=''] - Search term for filtering customers/consultations
	 * @param {number} [params.offset=0] - Pagination offset
	 * @param {number} [params.limit=13] - Number of records to return
	 * @param {boolean} [params.getArchived=false] - Whether to include archived consultations
	 * @param {string} params.startDate - Start date for date range filtering (ISO format)
	 * @param {string} params.endDate - End date for date range filtering (ISO format)
	 * @param {string} params.assigneeIdsJson - JSON string of assigned user IDs for filtering
	 * @param {string} params.statusJson - JSON string of status filters
	 * @param {string} [params.orderBy] - Field to order results by
	 * @param {string} [params.filterByDate='created_date'] - Date field to filter by
	 * @param {string} [params.sortOrder='DESC'] - Sort order (ASC or DESC)
	 * @returns {Promise<Object>} Promise that resolves to an object containing data array and number_of_records
	 */
	loadCustomersAndItsConsultations(params) {
		const errMsg = {display: 'Error Fetching Consultations'};
		const dfr = this.$q.defer();
		this.ConsultationSvc.getCustomersAndItsConsultations(params)
			.then(resObj => {
				const {data} = resObj;
				if (data?.success) dfr.resolve(data.payLoad);
				if (data?.error) dfr.reject(Object.assign(data.error, errMsg));
			})
			.catch(err => dfr.reject(Object.assign(err.data.error, errMsg)));
		return dfr.promise;
	}
}
//
let compMod = angular.module('mod.hlp.NavigatorHelper', []).service('NavigatorHelper', NavigatorHelper);
export default (compMod = compMod.name);
//
export function navigatorSvc() {
	return {
		$get: function () {
			return {
				getConsultationStatuses: () => {},
				getConsultationDetails: () => {},
				getAllUsersByProvider: () => {},
				getViewByDateFilterOptions: () => {},
				getConsultationLogs: () => {},
				getEventLostNote: () => {},
				markConsultationLost: () => {},
				revertLostStatus: () => {},
				loadCustomersAndItsConsultations: () => {},
			};
		},
	};
}
